module.exports = "/virtual-football-league/img/amblems/right/France/Fake_Marseille.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/France/Fake_Marseille.png
// module id = 2136
// module chunks = 4